// extracted by mini-css-extract-plugin
module.exports = {"CheckboxRound":"CustomCheckbox-module__CheckboxRound___2yz5Q"};